import { useState } from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <main className="contact-page">
      <div className="contact-hero container">
        <span className="eyebrow">Get in Touch</span>
        <h1 className="contact-title">We'd Love to Hear from You</h1>
        <p className="contact-sub">Have a question, feedback, or just want to say hello? Our team is always happy to help.</p>
      </div>

      <div className="container contact-layout">
        {/* Info */}
        <div className="contact-info">
          <div className="contact-card">
            <div className="contact-card-icon"><Mail size={22} /></div>
            <div>
              <h3 className="contact-card-title">Email Us</h3>
              <p className="contact-card-sub">We reply within 24 hours</p>
              <a href="mailto:KOAdryfruits2025@gmail.com" className="contact-link">KOAdryfruits2025@gmail.com</a>
            </div>
          </div>
          <div className="contact-card">
            <div className="contact-card-icon"><Phone size={22} /></div>
            <div>
              <h3 className="contact-card-title">Call Us</h3>
              <p className="contact-card-sub">Mon–Sun, 9AM–10PM</p>
              <a href="tel:+916367465206" className="contact-link">+91 6367465206</a>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon"><MapPin size={22} /></div>
            <div>
              <h3 className="contact-card-title">Our Office</h3>
              <p className="contact-card-sub">Visit by appointment</p>
              <span className="contact-link">G-31-A, Sector 2, VIDHYADHAR ENCLAVE –II, Central Spine, Vidyadhar Nagar, Jaipur, Rajasthan 302039</span>
            </div>
          </div>
          <div className="contact-card">
            <div className="contact-card-icon"><Clock size={22} /></div>
            <div>
              <h3 className="contact-card-title">Business Hours</h3>
              <p className="contact-card-sub">Monday – Sunday</p>
              <span className="contact-link">9:00 AM – 10:00 PM IST</span>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="contact-form-wrap">
          {sent ? (
            <div className="form-success">
              <span className="success-emoji">✅</span>
              <h3>Message Sent!</h3>
              <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
              <button className="btn-outline" onClick={() => setSent(false)}>Send Another</button>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2 className="form-title">Send a Message</h2>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Your Name</label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Rahul Sharma"
                    value={form.name}
                    onChange={e => setForm({ ...form, name: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-input"
                    placeholder="rahul@example.com"
                    value={form.email}
                    onChange={e => setForm({ ...form, email: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Subject</label>
                <select
                  className="form-input"
                  value={form.subject}
                  onChange={e => setForm({ ...form, subject: e.target.value })}
                  required
                >
                  <option value="">Select a topic</option>
                  <option>Order Issue</option>
                  <option>Product Quality</option>
                  <option>Return/Refund</option>
                  <option>Wholesale Enquiry</option>
                  <option>Partnership</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  className="form-input form-textarea"
                  placeholder="Tell us how we can help..."
                  value={form.message}
                  onChange={e => setForm({ ...form, message: e.target.value })}
                  required
                  rows={5}
                />
              </div>
              <button type="submit" className="btn-primary form-submit">Send Message</button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
